import React from 'react'
import FooTer from "../footer"
import "../../CSS/Blog/MemzVirus.css"

export default function Memztrozen() {
    return (
        <div>
            <h1 id="start">Memz Trozen Virus Demonstrations</h1>
            <hr />
            <h1 className="hd">In This Video How Memz Virus Desructive Mode Going On</h1>
            <div className="phishing-yt">
                <iframe id='yt' src="https://www.youtube.com/embed/G7qXorNwc5w" title="Warning! MEMZ Trojen Windows Demonstration ☠️ | Installed Most Dangerous Virus | #codearindam" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </div>
            <div className="yt-visit">
                <p id="sub">
                    If You Guys Injoy My Video So Visit My Youtube Channel:
                </p>
                <a id="cd" rel="noreferrer" href="https://www.youtube.com/channel/UClkomV-p7Ul_d4-Ye5uOvYg" target="_blank"><button>Code
                    Arindam</button></a>
            </div>
            <p className="ans">
                In This Video Using: <br />
                <br />
                1) VM BOX<br />
                2) WINDOWS 10<br />
                3) MEMZ VIRUS (JS)<br />
            </p>
            <p className="q">
                What Is Memz Virus?
            </p>
            <p className="ans">
                The MEMZ trojan is a malware in the form of a trojan horse made for Microsoft Windows.
            </p>
            <p className="q">
                Memz Trozen Actions..
            </p>
            <p className="ans">
                The virus gained notoriety for its unique and complex payloads, which automatically activate after each other, some with delay. Examples of payloads include randomly moving the cursor slightly, opening up satirical Google searches under Google.co.ck such as "how to remove a virus" and "how to get money" on the user's web browser, and opening various random Microsoft Windows programs (such as the calculator or command prompt). True to the program's name, many parts of the virus are based on Internet memes; for example, the virus overwrites the boot sector with an animation of Nyan Cat. Leurak also created a safer version of MEMZ called MEMZ-Clean. The clean version allows the non-destructive payloads to be safely tested and gives the user full control about which payloads are active
            </p>
            <p className="last">
                So Hope You Guys Injoy This Video And So Be Carefull And Stay Helthy And Have A Great Day...
            </p>
            <FooTer />
        </div>
    )
}
